export default {
  fr: {
    oldMembreTitre: "Anciens Membres",
    membreTitre: "Membres Actifs",
    "contactUs.sectionHeadNaoTitle": "Parce qu'on aime les cartes postales",
    "contactUs.sectionHeadNaoChild":
      'Pour nous <span class="highlight"><strong>contacter</strong></span>',
    "contactUs.address": "1100 Rue Notre-Dame Ouest, Montréal, QC H3C 1K3",

    "header.title": "Club scientifique de robotique",
    "header.school": "École de Technologie Supérieure, Montréal",

    "historique.title": "Historique du club",
    "historique.his1_date": "MAI 2017",
    "historique.his1":
      '<h4>Création du club étudiant <span class="highlight"><strong>Naova</strong></span> par Jonathan Fortin, Alexandre Doyle et Thierry Pouplier</h4>',
    "historique.his2_date": "24 JANIVIER 2018",
    "historique.his2":
      '<h4>Qualifié pour participer à la <span class="highlight"><strong>RoboCup Montréal 2018</strong></span> (RoboCupSoccer - Standard Platform)</h4>',
    "historique.his3_date": "15 au 22 JUIN 2018",
    "historique.his3":
      '<h4>Participation à la <span class="highlight"><strong>RoboCup Montréal 2018</strong></span> (RoboCupSoccer - Standard Platform)</h4> <div><p><u>JOUR 4 - JEUDI, 21 JUIN 2018</u></p><ul><li>Naova(1) vs. NTURoboPAL(2) - Challenge Shield Finals</li></ul><p><u>JOUR 3 - MERCREDI, 20 JUIN 2018</u></p><ul><li>UPennalizers(1) vs. Naova(3) - Challenge Shield Semi Finals</li><li>NTU RoboPAL(4) vs. Naova(1)</li></ul><p><u>JOUR 2 - MARDI, 19 JUIN 2018</u></p><ul><li>Naova(2) vs. Dutch Nao Team(0)</li><li>Naova(0) vs. Unbeatables(0)</li><li>UT Austin Villa(6) vs. Naova(0)</li></ul><p><u>JOUR 1 - LUNDI, 18 JUIN 2018</u></p><ul><li>Aztlan(0) vs. Naova(1)</li><li>Dutch Nao Team(0) vs. Naova(0)</li></ul><p><u>JOUR 0 - DIMANCHE, 17 JUIN 2018</u></p><ul><li>Naova(0) vs. Aztlan(2)</li></ul></div>',
    "historique.his4_date": "22 JUIN 2018",
    "historique.his4":
      '<h4>Finaliste (Challenge Shield) de la <span class="highlight"><strong>RoboCup Montréal 2018</strong></span> (RoboCupSoccer - Standard Platform)</h4>',
    "historique.his5_date": "2 au 8 JUILLET 2019",
    "historique.his5":
      '<h4>Participation à la <span class="highlight"><strong>RoboCup Australie 2019</strong></span> (RoboCupSoccer - Standard Platform)</h4> <div><p><u>JOUR 4 - VENDREDI, 5 JUILLET 2019</u></p><ul><li>Naova(1) vs. SABANA Herons(1)</li><li>Naova(1) vs. RoboEireann(1)</li><li>Cameila Dragons(2) vs. Naova(0)</li></ul><p><u>JOUR 3 - JEUDI, 4 JUILLET 2019</u></p><ul><li>TJark(8) vs. Naova(0)</li><li>SPQR(3) vs. Naova(0)</li><li>Dutch Nao Team(0) vs. Naova(0)</li></ul><p><u>JOUR 2 - MERCREDI, 3 JUILLET 2019</u></p><ul><li>Naova(0) vs. HTWK(10)</li></ul></div>',

    "imgages.sectionHeadNaoTitle": "Parce qu'un robot vaut mille photos",
    "images.sectionHeadNaoChild":
      'Notre travail en <span class="highlight"><strong>image</strong></span>',

    "definition.def1":
      "La mission principale de Naova est de participer à la RoboCup chaque année. Afin de nous qualifier, nous développons annuellement une innovation dans le monde de la robotique ou de l’intelligence artificielle et nous publions un article scientifique à ce sujet. Depuis quelques années, nous évoluons dans la division Challenger Shield. Notre objectif principal est de monter de division afin de compétitionner contre les meilleures équipes au monde dans la division Champions cup.",
    "definition.def2":
      "Naova se donne aussi comme mission de transmettre sa passion pour la robotique et le génie à la prochaine génération. Le club transmet cette passion au travers de nombreuses démonstrations avec des jeunes aux camps de jour de l’ÉTS ou lors des portes ouvertes par exemple. Nous aimons beaucoup faire des démonstrations autant aux jeunes qu’aux moins jeunes et ainsi faire découvrir l’univers de la robotique et de l’intelligence artificielle.",
    "definition.def3":
      "Finalement, Naova est aussi un club relativement petit qui regroupe une quinzaine d’étudiants de plusieurs génies. Les membres sont tissés serré et s’entraide autant dans les projets du club qu’à l’extérieur dans le cadre des cours ou autre.",
    "definition.buton": "Voir les résultats de la compétition!",

    "nav.history": "Historique",
    "nav.projects": "Projets",
    "nav.pictures": "Photos",
    "nav.press": "Presse",
    "nav.scientific": "Scientifique",
    "nav.team": "Équipe",
    "nav.sponsors": "Partenaires",
    "nav.langue": "en",

    "summary.title1": "UN BUT CLAIR",
    "summary.description1":
      "Notre objectif est de gagner la 1ère position à la Robocup, catégorie soccer 5 vs 5",
    "summary.title2": "UN ROBOT IDÉAL",
    "summary.description2":
      "À l'aide de sa forme humanoïde et des ses nombreux capteurs embarqués, le Booster K1 n'a (presque) rien à envier à Zidane.",
    "summary.linkTitle2": "Decouvrez le K1",
    "summary.title3": "DES SOUTIENS ESSENTIELS",
    "summary.description3":
      "Parce que sans eux, rien ne serait possible, nous tenons à remercier nos commanditaires.",
    "summary.linkTitle3": "Devenez commanditaires",
    "summary.title4": "UNE ÉQUIPE DE FOLIE",
    "summary.description4":
      "Venue des quatres coins de l'ETS, parée avec ses canards, l'équipe Naova n'a pas peur d'en découdre avec le reste du monde.",
    "summary.linkTitle4": "Decouvrez l'équipe",
    "summary.title5": "UN SUJET D'ÉTUDE PASSIONNANT",
    "summary.description5":
      "Jouer au soccer n'est pas si simple pour un robot. Les performances étant directement liées au code dictant leurs comportement, l'équipe Naova travaille d'arrache pied pour opimiser la performance de nos amis robotiques!",

    "presentation.sectionHeadNaoChild":
      'Naova : <span class="highlight"><strong>définition</strong></span>',
    "presentation.def": "Naova, c'est donc :",

    "project.sectionHeadNaoTitle": "Gotta keep workin'",
    "project.sectionHeadNaoChild":
      'Projets en <span class="highlight"><strong>cours</strong></span>',
    "project.title": "Progression",
    "project.description":
      "Notre équipe se concentre actuellement sur les tâches suivantes avec beaucoup (un peu trop?) d'acharnement.",
    "project.skill1": "Projet d'estimation de l'état de la partie",
    "project.skill2": "Projet d'interface graphique de stratégie",
    "project.skill3": "Projet de création d'outils d'installation",
    "project.skill4": "Projet prise de décision par apprentissage machine",
    "project.skill5": "Projet d'amélioration de la marche",
    "project.skill6": "Projet d'animation du robot",
    "project.skill7": "Projet de création de skills génériques",
    "project.skill8": "Projet sur la communication entre robot",
    "project.skill9": "Projet de mouvement de la tête",

    "team.title": "L'équipe Naova",
    "team.description": "Les humains derrière les robots",
    "team.capitain": "Capitaine",
    "team.cocap": "Co-Capitaine",
    "team.treasurer": "Trésorier",
    "team.founder": "Fondateur",
    "team.administration": "Administration",
    "team.technique": "Directeur technique",
    "team.specialiste": "Spécialiste technique",
    "team.student": "Étudie en ",
    "team.cursus": "Cheminement universitaire en technologie",
    "team.ti": "Génie technologies de l'information",
    "team.log": "Génie logiciel",
    "team.gpa": "Génie de la production automatisée",
    "team.mec": "Génie mécanique",
    "team.ele": "Génie électrique",
    "team.gol": "Génie des opérations et de la logistique",
    "team.master_mec": "Maîtrise en génie mécanique",
    "team.master_ele": "Maîtrise en génie électrique",
    "team.master_log": "Maîtrise en génie logiciel",
    "team.master_ti": "Maîtrise en génie technologies de l'information",
    "team.master_gpa": "Maîtrise en génie de la production automatisée",
    "team.master_ti_sante": "Maîtrise en génie des technologies de la santé",

    "sponsors.title": "Partenaires",
    "sponsors.description": "Merci à nos partenaires!",
    "sponsors.becomeSponsors": "Devenir un partenaire!",
    "sponsors.donation": "Faire un don!",
    "sponsors.diamond": "Diamant",
    "sponsors.platinum": "Platine",
    "sponsors.gold": "Or",
    "sponsors.silver": "Argent",
    "sponsors.bronze": "Bronze",
    "sponsors.sp1": "Association Étudiante de l'ETS",
    "sponsors.sp2": "Ubisoft Montréal",
    "sponsors.sp3": "Fond de recherche du Québec",
    "sponsors.sp4": "École de technologie supérieure",
    "sponsors.sp5": "Équisoft",
    "sponsors.sp8": "Systèmes de gestion Alain Legault inc.",
    "sponsors.sp9": "Teledyne Technologies",
    "sponsors.sp10": "PCI Automatisation Industrielle",
    "sponsors.sp11": "Rousseau Metal International",
    "sponsors.sp12": "Desjardins",
    "sponsors.sp13": "Genium360",
    "sponsors.sp14": "Air Canada",

    "press.source": "Source: ",
    "press.title": "La presse de Naova",
    "press.year": "Année",
    "press.btn": "En savoir plus",
    "press.date1": "23 août 2017",
    "press.date2": "30 juin 2017",
    "press.date3": "4 mai 2017",
    "press.date4": "9 mai 2017",
    "press.date5": "28 janvier 2018",
    "press.date6": "9 mai 2018",
    "press.date7": "10 juin 2018",
    "press.date8": "18 juin 2018",
    "press.date9": "11 juillet 2018",
    "press.date10": "13 juillet 2018",
    "press.date11": "13 octobre 2018",
    "press.date12": "15 novembre 2018",
    "press.date13": "Automne 2018",
    "press.date14": "27 janvier 2019",

    "scientific.title": "Les articles scientifiques de Naova",
    "scientific.btn": "Lire le document",
    "scientific.github": "Lien GitHub",
    "sci.date1": "Décembre 2018",
    "sci.date2": "Janvier 2019",
  },
  en: {
    oldMembreTitre: "Old Members",
    membreTitre: "Current Members",
    "contactUs.sectionHeadNaoTitle": "We love getting cards!",
    "contactUs.sectionHeadNaoChild":
      'Contact <span class="highlight"><strong>us</strong></span>',
    "contactUs.address": "1100 Notre-Dame Street West, Montréal, QC H3C 1K3",

    "header.title": "Robotic scientific club",
    "header.school": "Ecole de Technologie Supérieure, Montréal",

    "historique.title": "Club history",
    "historique.his1_date": "MAY 2017",
    "historique.his1":
      '<h4>Creation of the student club <span class="highlight"><strong>Naova</strong></span> by Jonathan Fortin, Alexandre Doyle and Thierry Pouplier</h4>',
    "historique.his2_date": "JANUARY 24, 2018",
    "historique.his2":
      '<h4>Qualifed to participate in the <span class="highlight"><strong>RoboCup Montréal 2018</strong></span> (RoboCupSoccer - Standard Platform)</h4>',
    "historique.his3_date": "JUNE 15-22, 2018",
    "historique.his3":
      '<h4>Participated to in the <span class="highlight"><strong>RoboCup Montréal 2018</strong></span> (RoboCupSoccer - Standard Platform)</h4><div><p><u>DAY 4 - THURSDAY, JUNE, 21 2018</u></p><ul><li>Naova(1) vs. NTURoboPAL(2) - Challenge Shield Finals</li></ul><p><u>DAY 3 - WEDNESDAY, JUNE, 20 2018</u></p><ul><li>UPennalizers(1) vs. Naova(3) - Challenge Shield Semi Finals</li><li>NTU RoboPAL(4) vs. Naova(1)</li></ul><p><u>DAY 2 - TUESDAY, JUNE, 19 2018</u></p><ul><li>Naova(2) vs. Dutch Nao Team(0)</li><li>Naova(0) vs. Unbeatables(0)</li><li>UT Austin Villa(6) vs. Naova(0)</li></ul><p><u>DAY 1 - MONDAY, JUNE, 18 2018</u></p><ul><li>Aztlan(0) vs. Naova(1)</li><li>Dutch Nao Team(0) vs. Naova(0)</li></ul><p><u>DAY 0 - SUNDAY, JUNE, 17 2018</u></p><ul><li>Naova(0) vs. Aztlan(2)</li></ul></div>',
    "historique.his4_date": "JUNE 22, 2018",
    "historique.his4":
      '<h4>Finalist (Challenge Shield) to in the <span class="highlight"><strong>RoboCup Montréal 2018</strong></span> (RoboCupSoccer - Standard Platform)</h4>',
    "historique.his5_date": "JULY 2-8, 2019",
    "historique.his5":
      '<h4>Participated to in the <span class="highlight"><strong>RoboCup Australie 2019</strong></span> (RoboCupSoccer - Standard Platform)</h4> <div><p><u>DAY 4 - FRIDAY, JULY, 5 2019</u></p><ul><li>Naova(1) vs. SABANA Herons(1)</li><li>Naova(1) vs. RoboEireann(1)</li><li>Cameila Dragons(2) vs. Naova(0)</li></ul><p><u>DAY 3 - THURSDAY, JULY, 4 2019</u></p><ul><li>TJark(8) vs. Naova(0)</li><li>SPQR(3) vs. Naova(0)</li><li>Dutch Nao Team(0) vs. Naova(0)</li></ul><p><u>DAY 2 - WEDNESDAY, JULY, 3 2019</u></p><ul><li>Naova(0) vs. HTWK(10)</li></ul></div>',

    "imgages.sectionHeadNaoTitle": "Because a robot is worth a thousand photos",
    "images.sectionHeadNaoChild":
      'Our work in <span class="highlight"><strong>pictures</strong></span>',

    "definition.def1":
      "Naova's main mission is to take part in the RoboCup every year. To qualify, each year we develop an innovation in the world of robotics or artificial intelligence and publish a scientific paper on the subject. For the past few years, we've been competing in the Challenger Shield division. Our main objective is to move up a division to compete against the best teams in the world in the Champions Cup division.",
    "definition.def2":
      "Naova's mission is also to pass on its passion for robotics and engineering to the next generation. The club transmits this passion through numerous demonstrations with children at ÉTS day camps and open houses. We love demonstrating to young and old alike, and helping them discover the world of robotics and artificial intelligence.",
    "definition.def3":
      "Finally, Naova is also a relatively small club, bringing together approximately 15 students from a number of engineering disciplines. The members are very close-knit, helping each other with projects both inside and outside the club.",
    "definition.buton": "Show the competition's results!",

    "nav.history": "History",
    "nav.projects": "Projects",
    "nav.pictures": "Pictures",
    "nav.press": "Press",
    "nav.scientific": "Scientific",
    "nav.tem": "Team",
    "nav.sponsors": "Sponsors",
    "nav.langue": "fr",

    "summary.title1": "A CLEAR GOAL",
    "summary.description1": "We aim to win in Robocup, category soccer 5vs5.",
    "summary.title2": "AN IDEAL ROBOT",
    "summary.description2":
      "With the help of its humanoid shape and its numerous embarked captors, the Booster K1 robot has (almost) nothing to envy from Zidane.",
    "summary.linkTitle2": "Learn more about the K1",
    "summary.title3": "NECESSARY SUPPORT",
    "summary.description3":
      "Without them nothing would be possible, we want to thank our sponsors.",
    "summary.linkTitle3": "Get involved as a sponsor",
    "summary.title4": "AN INCREDIBLE TEAM",
    "summary.description4":
      "Coming from the four corners of ETS, paired with their ducks, Naova’s team fear nothing in thisworld.",
    "summary.linkTitle4": "Learn more about the team",
    "summary.title5": "A THRILLING SUBJECT TO STUDY",
    "summary.description5":
      "Playing soccer isn’t that simple for a robot. The performance being directly linked to the code dictating their comportment, the team works hard to optimize the performance of our robotic friends.",

    "presentation.sectionHeadNaoChild":
      'Naova : <span class="highlight"><strong>definition</strong></span>',
    "presentation.def": "Naova, briefly :",

    "project.sectionHeadNaoTitle": "Gotta keep workin'",
    "project.sectionHeadNaoChild":
      'Projects in <span class="highlight"><strong>progress</strong></span>',
    "project.title": "Progression",
    "project.description":
      "Our team works (too?) hard on the following projects.",
    "project.skill1": "Project to estimate the state of the game",
    "project.skill2": "Strategy GUI project",
    "project.skill3": "Project for creating installation tools",
    "project.skill4": "Machine learning decision making project",
    "project.skill5": "Project for the walk improvement",
    "project.skill6": "Robot animation project",
    "project.skill7": "Project to create the generics skills",
    "project.skill8": "Project about robot communication",
    "project.skill9": "Project of head movement",

    "team.title": "Naova's team",
    "team.description": "Humans behind bots",
    "team.capitain": "Captain",
    "team.cocap": "Co-Captain",
    "team.founder": "Founder",
    "team.treasurer": "Treasurer",
    "team.administration": "Administration",
    "team.technique": "Technical director",
    "team.specialiste": "Technical specialist",
    "team.student": " student",
    "team.cursus": "Technological Academic Path",
    "team.ti": "Information Technology engineering",
    "team.log": "Software engineering",
    "team.gpa": "Engineering of Automated Manufacturing",
    "team.mec": "Mechanical engineering",
    "team.ele": "Electrical engineering",
    "team.gol": "Operations and Logistics engineering",
    "team.master_mec": "Master in Mechanical engineering",
    "team.master_ele": "Master in Electrical engineering",
    "team.master_log": "Master in Software enginnering",
    "team.master_ti": "Master in Information Technology engineering",
    "team.master_gpa": "Master in Automated Manufacturing enginnering",
    "team.master_ti_sante": "Master in Engineering in Healthcare Technology",

    "sponsors.title": "Sponsors",
    "sponsors.description": "Thanks for all our sponsors!",
    "sponsors.becomeSponsors": "Become a sponsors!",
    "sponsors.donation": "Make a donation!",
    "sponsors.diamond": "Diamond",
    "sponsors.platinum": "Platinum",
    "sponsors.gold": "Gold",
    "sponsors.silver": "Silver",
    "sponsors.bronze": "Bronze",
    "sponsors.sp1": "ETS's Student Association",
    "sponsors.sp2": "Ubisoft Montréal",
    "sponsors.sp3": "Fond de recherche du Québec",
    "sponsors.sp4": "Ecole de technologie superieure",
    "sponsors.sp5": "Equisoft",
    "sponsors.sp6": "Octasic",
    "sponsors.sp7": "Sherweb",
    "sponsors.sp8": "Systèmes de gestion Alain Legault inc.",
    "sponsors.sp9": "Teledyne Technologies",
    "sponsors.sp10": "PCI Automatisation Industrielle",
    "sponsors.sp11": "Rousseau Metal International",
    "sponsors.sp12": "Desjardins",

    "press.source": "Source: ",
    "press.title": "Naova's press",
    "press.year": "Year",
    "press.btn": "Show more",
    "press.date1": "August 23, 2017",
    "press.date2": "June 30, 2017",
    "press.date3": "May 4, 2017",
    "press.date4": "May 9, 2017",
    "press.date5": "January 28, 2018",
    "press.date6": "May 9, 2018",
    "press.date7": "June 10, 2018",
    "press.date8": "June 18, 2018",
    "press.date9": "July 11, 2018",
    "press.date10": "July 13, 2018",
    "press.date11": "October 13, 2018",
    "press.date12": "November 15, 2018",
    "press.date13": "Fall 2018",
    "press.date14": "January 27, 2019",

    "scientific.title": "Naova's scientific articles",
    "scientific.btn": "Read document",
    "scientific.github": "GitHub link",
    "sci.date1": "December, 2018",
    "sci.date2": "January, 2019",
    "sci.date3": "April, 2019",
    "sci.date4": "December, 2019",
    "sci.date5": "January, 2021",
  },
};
